__turbopack_context__.v({
  "frame": "ItineraryTimeline-module__xRnjZG__frame",
  "frameNoDesktopBackground": "ItineraryTimeline-module__xRnjZG__frameNoDesktopBackground",
  "heading": "ItineraryTimeline-module__xRnjZG__heading",
  "headingRow": "ItineraryTimeline-module__xRnjZG__headingRow",
  "itinerarySection": "ItineraryTimeline-module__xRnjZG__itinerarySection",
  "itinerarySectionNoDesktopSpacing": "ItineraryTimeline-module__xRnjZG__itinerarySectionNoDesktopSpacing",
  "seeOnMapButton": "ItineraryTimeline-module__xRnjZG__seeOnMapButton",
  "timelineContent": "ItineraryTimeline-module__xRnjZG__timelineContent",
  "timelineDate": "ItineraryTimeline-module__xRnjZG__timelineDate",
  "timelineDot": "ItineraryTimeline-module__xRnjZG__timelineDot",
  "timelineGroup": "ItineraryTimeline-module__xRnjZG__timelineGroup",
  "timelineHeading": "ItineraryTimeline-module__xRnjZG__timelineHeading",
  "timelineItems": "ItineraryTimeline-module__xRnjZG__timelineItems",
  "timelineTrack": "ItineraryTimeline-module__xRnjZG__timelineTrack",
  "timelineWrapper": "ItineraryTimeline-module__xRnjZG__timelineWrapper",
});
